export const servicesData = [
    {
        "id": 0,
        "title": "التدريب عبر الإنترنت",
        "subTitle": "استمتع بخطط تغذية وبرامج لياقة مصممة خصيصًا لك، مع دعم نفسي مستمر عبر المنصات الرقمية لتحقيق أهدافك الصحية.",
        "features": [
            {
                "id": 0,
                "desc": "خطط مخصصة تناسب احتياجاتك الشخصية وأسلوب حياتك."
            },
            {
                "id": 1,
                "desc": "متابعة مباشرة مع خبراء التغذية واللياقة عبر الإنترنت."
            }
        ],
        "action": "ابدأ تدريبك الآن",
        type:"people",
        img: "/services/service1.png"
    },
    {
        "id": 1,
        "title": "التغذية العلاجية",
        "subTitle": "خطط غذائية متكاملة مخصصة للحالات الطبية مثل السكري، السمنة، والتعافي بعد العمليات لضمان صحة أفضل.",
        "features": [
            {
                "id": 0,
                "desc": "أنظمة غذائية صحية تناسب الحالة الطبية الفردية."
            },
            {
                "id": 1,
                "desc": "إشراف من خبراء تغذية معتمدين لمتابعة تقدمك."
            }
        ],
        "action": "احجز استشارتك الآن",
        type:"people",
        img: "/services/service2.png"
    },
    {
        "id": 2,
        "title": "تغذية وتدريب الرياضيين",
        "subTitle": "برامج مخصصة للرياضيين المحترفين لتحسين الأداء البدني من خلال خطط غذائية وتمارين مكثفة.",
        "features": [
            {
                "id": 0,
                "desc": "خطط غذائية متخصصة لتعزيز الأداء الرياضي."
            },
            {
                "id": 1,
                "desc": "خطط غذائية متخصصة لتعزيز الأداء الرياضي."
            }
        ],
        "action": "ابدأ برنامجك الاحترافي",
        type:"people",
        img: "/services/service3.png"
    },
    {
        "id": 3,
        "title": "إدارة الوزن",
        "subTitle": "برامج متكاملة لفقدان الوزن أو زيادته، وتحقيق التوازن المثالي للجسم بطريقة صحية وآمنة.",
        "features": [
            {
                "id": 0,
                "desc": "خطط مخصصة بناءً على تقييم دقيق لحالتك الصحية."
            },
            {
                "id": 1,
                "desc": "متابعة دورية لتحليل التقدم وتحقيق الأهداف."
            }
        ],
        "action": "ابدأ خطتك اليوم",
        type:"people",
        img: "/services/service4.png"
    },
    {
        "id": 4,
        "title": "العلاج الطبيعي",
        "subTitle": "استمتع بجلسات علاجية واستشفائية باستخدام أساليب طبيعية مثل الأعشاب وتقنيات إدارة التوتر.",
        "features": [
            {
                "id": 0,
                "desc": "علاجات طبيعية تساعد في تخفيف التوتر وتحسين الصحة العامة."
            },
            {
                "id": 1,
                "desc": "برامج استشفائية لإعادة تأهيل العضلات والمفاصل."
            }
        ],
        "action": "احجز جلستك الآن",
        type:"people",
        img: "/services/service5.png"
    },
    {
        "id": 5,
        "title": "دعم الصحة النفسية",
        "subTitle": "استشارات نفسية فردية لتحسين الصحة النفسية وتقليل التوتر وتعزيز الثقة بالنفس.",
        "features": [
            {
                "id": 0,
                "desc": "جلسات فردية مع متخصصين لتحسين الصحة النفسية."
            },
            {
                "id": 1,
                "desc": "تمارين اليقظة الذهنية والتأمل لتعزيز التركيز."
            }
        ],
        "action": "احصل على دعمك الآن",
        type:"people",
        img: "/services/service6.png"
    }
]


export const servicesCompanyData = [
    {
        "id": 0,
        "title": "التدريب الرياضي الجماعي",
        "subTitle": "تدريبات رياضية جماعية تهدف إلى تطوير المهارات في الألعاب المختلفة مثل كرة القدم، التنس، والسباحة.",
        "features": [
            {
                "id": 0,
                "desc": "تدريبات تناسب جميع المستويات (مبتدئين - محترفين)."
            },
            {
                "id": 1,
                "desc": "تحسين الأداء البدني والتكتيكي مع مدربين محترفين."
            }
        ],
        "action": "انضم إلى فريقك الآن",
        type:"company",
        img: "/services/companyService1.png"
    },
    {
        "id": 1,
        "title": "برامج العافية للشركات",
        "subTitle": "خطط صحية متكاملة للشركات والمصانع والفنادق لتحسين صحة الموظفين وزيادة الإنتاجية.",
        "features": [
            {
                "id": 0,
                "desc": "ورش عمل توعوية حول اللياقة والتغذية في بيئة العمل."
            },
            {
                "id": 1,
                "desc": "تحديات رياضية تحفز الموظفين وتعزز الروح الجماعية."
            }
        ],
        "action": "اطلب برنامجًا لشركتك",
        type:"company",
        img: "/services/companyService2.png"
    },
    {
        "id": 2,
        "title": "اللياقة التعليمية للأطفال",
        "subTitle": "برامج رياضية ممتعة للأطفال تهدف إلى تعزيز اللياقة البدنية وتنمية المهارات الرياضية بطريقة إبداعية.",
        "features": [
            {
                "id": 0,
                "desc": "تدريبات مصممة لتطوير القدرات البدنية للأطفال."
            },
            {
                "id": 1,
                "desc": "بيئة آمنة وممتعة تعزز النشاط البدني."
            }
        ],
        "action": "ابدأ برنامج مدرستك",
        type:"company",
        img: "/services/companyService3.png"
    },
    {
        "id": 3,
        "title": "الرفاهية البيئية  ",
        "subTitle": "برامج لتعزيز نمط حياة صحي ومستدام من خلال ممارسات صديقة للبيئة في التغذية واللياقة.",
        "features": [
            {
                "id": 0,
                "desc": "نصائح لتعزيز العادات الصحية بطريقة بيئية مستدامة."
            },
            {
                "id": 1,
                "desc": "أنشطة مجتمعية لتعزيز الوعي البيئي."
            }
        ],
        "action": "شارك في المبادرة الآن",
        type:"company",
        img: "/services/companyService4.png"
    },
    {
        "id": 4,
        "title": "دعم الصحة النفسية الجماعية",
        "subTitle": "جلسات جماعية لدعم الصحة النفسية، تشمل تمارين التأمل وتعزيز الثقة ضمن بيئة آمنة وداعمة.",
        "features": [
            {
                "id": 0,
                "desc": "جلسات تفاعلية لتحسين الصحة النفسية ضمن مجموعة داعمة."
            },
            {
                "id": 1,
                "desc": "أساليب علاجية تساعد على التخلص من التوتر والقلق."
            }
        ],
        "action": "احجز جلسة جماعية الآن",
        type:"company",
        img: "/services/service6.png"
    }
]